<template>
    <div>
        <h2 class="intro-heading" :class="[hasRead(slug) ? 'did-read' : '', headingSize]" v-on:click="didSelectStory(story.slug)">{{ story.name }}</h2>
        <div class="intro-meta">
            <div v-if="false && !hasRead(slug)" class="publisher">
                <img :src="publisherIcon()"/>
            </div>
            <div v-else>
                <status :slug="slug"></status>
            </div>
            <router-link :to="`/story/${story.slug}`">
                <div class="intro-time" :class="[(hasRead(slug)) ? 'did-read' : '']" >
                    <div class="inner">
                        <global-svg type="clock" color="#868C8C" height="11px"></global-svg>
                        <span>{{ getLastUpdated() }}</span>
                    </div>
                </div>
            </router-link>
        </div>
        <p v-if="!hideSummary" class="intro-summary" :class="[(hasRead(slug)) ? 'did-read' : '', limitSummary]" v-on:click="didSelectStory(story.slug)">{{ story.synopsis }}</p>
        <div class="intro-topics" v-if="story">
            <span v-for="(topic, idx) in topics" :key="idx">
              <router-link class="topic-tag" :to="`/topic/${topic.topic_code}`" :href="`/topic/${topic.topic_code}`" :title="topic.topic_name">{{ topic.topic_name | ellipsis }}</router-link>
              <!-- <span v-if="idx !== 2" class="topic-tag-divider">, </span> -->
            </span>
        </div>
    </div>
</template>

<script>
    import { Mixins } from '../mixins'
    import Status from './Status';
    import dayjs from 'dayjs'
    import relativeTime from 'dayjs/plugin/relativeTime'
    dayjs.extend(relativeTime)

    export default {
      props: ['headingSize', 'limitSummary', 'hideSummary', 'slug', 'story', 'hideUpdated'],
      mixins: [Mixins],
      components: {
        Status
      },
      computed: {
        isSignedIn() {
            return this.$store.getters.isLoggedIn; 
        },
        topics() {
            if (this.story && this.story.topics) {
              // console.log(this.story.topics.filter(a => a.meta_wiki));
              return this.story.topics.filter(a => a.meta_wiki).slice(0,3);
            }

            return [];
        },
      },
      methods: {
        getLastUpdated() {
            let timeAgo = dayjs(this.story.last_published_at);
            let difference = timeAgo.from(dayjs(), 'y')

            if (difference < 0) {
                return 'Unknown'
            } else {
                return timeAgo.fromNow();
            }
        }
      },
    }
</script>

<style lang="scss" scoped>
	@import '~styles/_variables';
    @import '../grid.scss';

    .intro-heading,
    .intro-summary {
        cursor: pointer;
        overflow: hidden;
    }

    .intro-heading {
        font-weight: bold;
        margin: 0;

        &.large {
            font-size: 22px;
            line-height: 1.25;
        }

        &.medium {
            font-size: 18px;
            line-height: 1.25;
        }

        &.small {
            font-size: 15px;
            line-height: 1.35;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }

    .intro-meta {
        display: flex;
        align-items: center;
        margin: 12px 0;

        .intro-time {
            display: flex;
            flex-direction: column;
            font-size: 12px;
            padding-bottom: 2px;
            margin-left: 8px;

            .inner {
                display: flex;

                &:not(:first-child) {
                    margin-top: 5px;
                }
            }

            span {
                margin: 0 5px;

                &.regular {
                    font-weight: normal;
                }
            }
        }
    }

    .intro-summary {
        margin-top: 4px;
        font-size: 0.9em;
        line-height: 1.4;
        margin-bottom: 0;

        &.limitSummary {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }

    .intro-topics {
        margin-top: 6px;
        line-height: 1.0;

        .topic-tag {
            font-family: $ff-tag;
            font-weight: normal;
            //color: $base-secondary;
            font-size: 10px;
            background: $highlight-primary;
            color: $base-primary;
            margin-right: 4px;
            padding: 1px 5px;
            border-radius: 2px;
            white-space: nowrap;
            display: inline-block;
        }

        // .topic-tag:hover:before {
        //     content: "Topic: ";
        // }
}

</style>